const _localStorage: any = localStorage;

const LocalStorageHelper = {
    getToken: function () {
        return localStorage.getItem('token')
    },
    saveToken: function (token:any = null) {
        localStorage.setItem('token', token)
    },
    removeToken: function () {
        if (this.getUserData())
            localStorage.removeItem('token')
    },

    saveUserData: function (data: any) {
        localStorage.setItem("userData", JSON.stringify(data));
        window.dispatchEvent(new Event("uData"));
    },
    getUserData: function () {
        // return JSON.parse(localStorage.getItem('userData'));
        return JSON.parse(localStorage.getItem("userData") || '""');
    },
    removeUserData: function () {
        localStorage.removeItem('userData');
        // if (this.getUserData())
        //     return JSON.parse(localStorage.removeItem('userData'));
    },
    
    saveDarkMode: function (darModeVal:any = false) {
        localStorage.setItem("darkMode", darModeVal);
        window.dispatchEvent(new Event("darkMode"));
    },

    isDarkMode: function () {
        return _localStorage.getItem('darkMode') != null  && _localStorage.getItem('darkMode').toLowerCase() === 'true';
    },

    isLoggedIn: function () {
        return localStorage.getItem('userData') !== null;
    },

    saveIsForgotPassword: function (isForgotPasswordVal:any = false) {
        localStorage.setItem("isForgotPassword", isForgotPasswordVal)
    },
    isForgotPassword: function () {
        return _localStorage.getItem('isForgotPassword') != null  && _localStorage.getItem('isForgotPassword').toLowerCase() === 'true';
    },

    clearLocalStorage: function () {
        localStorage.clear();
    },

    saveBrowsingHistoryData: function (data: any) {
        localStorage.setItem("browsingHistoryData", JSON.stringify(data));
    },

    getBrowsingHistoryData: function () {
        return JSON.parse(localStorage.getItem("browsingHistoryData") || '""');
    },
    removeBrowsingHistoryData: function () {
        localStorage.removeItem('browsingHistoryData');
        // if (this.getBrowsingHistoryData())
        //     return JSON.parse(localStorage.removeItem('browsingHistoryData'));
    },
    saveToggledHistory: function (toggledHistoryVal:any = false) {
        localStorage.setItem("toggledHistory", toggledHistoryVal);
        window.dispatchEvent(new Event("toggledHistory"));
    },

    istoggledHistory: function () {
        return _localStorage.getItem('toggledHistory') != null  && _localStorage.getItem('toggledHistory').toLowerCase() === 'true';

    },
    saveUpdateUserProfile: function (data: boolean) {
        localStorage.setItem("updateUserProfile", JSON.stringify(data));
    },
    isUpdateUserProfile: function () {
        let _updateUserProfile: any = localStorage?.getItem("updateUserProfile") == 'true';
        return _updateUserProfile;
    },
}

export default LocalStorageHelper;